<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <vue-headful
      :title="getTitleSeo()"
      :description="getDescSeo()"
      :keywords="getKeywordsSeo()"
    />

    <Banner
      :background="row.image ? row.image.url : ''"
      :title="!pgLoading ? row.title : ''"
      :subtitle="
        !pgLoading ? ($i18n.locale == 'en' ? item.en.title : item.ar.title) : ''
      "
    >
    </Banner>

    <section class="blog-details-area pt-50 pb-50">
      <div class="container">
        <div class="row">
          <div class="blog__thumb mb-35 w-100">
            <img
              :src="row.image ? row.image.url : '/assets/img/logo/min-logo.png'"
              height="450px"
              width=""
              loading="lazy"
              alt=""
            />
          </div>
          <div class="col-xl-8 col-lg-8 col-md-12">
            <div class="blogs-details-left-area mb-50">
              <div
                class="blog blogs-02 mb-40 wow fadeInUp2 animated"
                data-wow-delay=".1s"
              >
                <!-- <div class="blog__thumb mb-35">
                  <img
                    :src="
                      row.image
                        ? row.image.url
                        : '/assets/img/logo/min-logo.png'
                    "
                    loading="lazy"
                    height="450px"
                    alt=""
                  />
                </div> -->
                <div class="blog__content">
                  <!-- <a class="tag" href="#">{{ $t('app.charity_work') }}</a> -->

                  <!-- <div class="blogs-details-thumb mb-10">
                    <img
                    loading="lazy"
                      v-if="row.image"
                      class="img-fluid"
                      :src="row.image.url"
                      :alt="row.title"
                    />
                  </div> -->
                  <h5 class="blog-title mb-20">{{ row.title }}</h5>
                  <ul class="">
                    <li><i class="far fa-calendar-alt"></i> {{ row.date }}</li>
                  </ul>

                  <p class="mb-35" v-html="row.body"></p>

                  <p class="mb-25" v-html="row.short_body"></p>
                </div>
              </div>
              <!-- <div class="blog-details-list">
                  <h3 class="cases-title mb-15">عنوان فرعي اخر</h3>
                  <p>
                    هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم
                    توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل
                    هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد
                    الحروف
                  </p>
                  <ul
                    class="about_list mt-15 mb-20 wow fadeInUp2 animated"
                    data-wow-delay=".2s"
                  >
                    <li>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة</li>
                    <li>لقد تم توليد هذا النص من مولد النص العربى</li>
                    <li>
                      حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى
                      إضافة إلى زيادة عدد الحروف
                    </li>
                    <li>لقد تم توليد هذا النص من مولد النص العربى</li>
                  </ul>
                </div>

                <div class="author grey-bg2 fix mb-60">
                  <div class="author__content fix">
                    <h4 class="semi-02-title">اسم محرر الخبر</h4>
                    <p>
                      هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم
                      توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل
                      هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد
                      الحروف التى يولدها التطبيق.
                    </p>
                    <div class="header-social post-share-icon pt-10">
                      <a href="#"><i class="fab fa-facebook-f"></i></a>
                      <a href="#"><i class="fab fa-twitter"></i></a>
                      <a href="#"><i class="fab fa-youtube"></i></a>
                      <a href="#"><i class="fab fa-vimeo-square"></i></a>
                    </div>
                  </div>
                </div>-->
            </div>
          </div>
          <!-- <div class="col-xl-4 col-lg-4 col-md-12">
            <div class="standard-right-area">
              <div
                class="widget grey-bg2 mb-30 wow fadeInUp2 animated"
                data-wow-delay=".1s"
              >
                <div class="widget-post widget-post-02">
                  <h3 class="cases-title mb-20">اخبار متعلقة</h3>
                  <ul>
                    <li>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/blog/22.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h4><a href="#">عنوان الخبر</a></h4>
                          <a class="view_btn" href="#"
                            ><i
                              :class="[
                                locale == 'ar'
                                  ? 'far fa-chevron-right'
                                  : 'far fa-chevron-left',
                              ]"
                            ></i>
                            تفاصيل</a
                          >
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/blog/22.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h4><a href="#">عنوان الخبر</a></h4>
                          <a class="view_btn" href="#"
                            ><i
                              :class="[
                                locale == 'ar'
                                  ? 'far fa-chevron-right'
                                  : 'far fa-chevron-left',
                              ]"
                            ></i>
                            تفاصيل</a
                          >
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/blog/22.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h4><a href="#">عنوان الخبر</a></h4>
                          <a class="view_btn" href="#"
                            ><i
                              :class="[
                                locale == 'ar'
                                  ? 'far fa-chevron-right'
                                  : 'far fa-chevron-left',
                              ]"
                            ></i>
                            تفاصيل</a
                          >
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/blog/22.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h4><a href="#">عنوان الخبر</a></h4>
                          <a class="view_btn" href="#"
                            ><i
                              :class="[
                                locale == 'ar'
                                  ? 'far fa-chevron-right'
                                  : 'far fa-chevron-left',
                              ]"
                            ></i>
                            تفاصيل</a
                          >
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="widget grey-bg2 mb-30 wow fadeInUp2 animated"
                data-wow-delay=".1s"
              >
                <div class="widget-cat-btn">
                  <h3 class="cases-title mb-30">الكلمات الدلالية</h3>
                  <div class="cat-list">
                    <a class="cat-btn" href="#">{{ $t("app.charity_work") }}</a>
                    <a class="cat-btn" href="#">تعليم</a>
                    <a class="cat-btn" href="#">صحة</a>
                    <a class="cat-btn" href="#">انشائات</a>
                    <a class="cat-btn" href="#">عقيقة</a>
                    <a class="cat-btn" href="#">{{ $t("app.count2") }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      //
      item: {
        image: {
          url: "/assets/img/bg/12.jpg",
        },
        en: {
          title: "achievements",
        },
        ar: {
          title: "الإنجازات",
        },
      },
      items: [],
      refs: "pages",
      locale: "ar",
      pgLoading: true,
      row: "",
    };
  },
  mounted() {},
  watch: {
    $route() {
      //
      this.fetchData();
    },
  },
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    this.fetchData();
  },
  methods: {
    getTitleSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_title
          : meta.en.meta_title
        : "";
      return data;
    },
    getDescSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_description
          : meta.en.meta_description
        : "meta_description";
      return data;
    },
    getKeywordsSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_keywords
          : meta.en.meta_keywords
        : "meta_keywords";
      return data;
    },

    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/achievements/" + this.$route.params.slug,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.row = res.data.row;
        })
        .catch(() => {
          this.$router.push({
            name: "404",
          });
        })
        .finally(() => {});
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
